import Calculator from './components/Calculator';
import SmallCalculator from './components/SmallCalculator';

export default Calculator;
export {
  SmallCalculator,
};
